import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import {
  list,
  GET,
  CREATE,
  UPDATE,
  DELETE,
  CLEAR
} from '@hobs/constants/activity';
import { actionCreator } from './utils/utils';

export function getActivities(sorId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`StatementOfRequirements/${sorId}/Activities`)
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: list.REQUEST };
  }
  function success(annexes) {
    return { type: list.SUCCESS, annexes };
  }
  function failure(error) {
    return { type: list.FAILURE, error };
  }
}

export const getActivity = activityId =>
  actionCreator(`StatementOfRequirements/Activities/${activityId}`, GET);

export const createActivity = (body, sorId) =>
  actionCreator(`StatementOfRequirements/${sorId}/Activities`, CREATE, {
    body: body,
    method: 'POST'
  });

export const updateActivity = (activityId, body) =>
  actionCreator(`StatementOfRequirements/Activities/${activityId}`, UPDATE, {
    body: body,
    method: 'PUT'
  });

export const deleteActivity = activityId =>
  actionCreator(`StatementOfRequirements/Activities/${activityId}`, DELETE, {
    method: 'DELETE'
  });

export function clearActivity() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}
